import React, { useState } from 'react';
import contactBanner from '../../assets/images/banners/contact_banner.png';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Aquí puedes manejar el envío del formulario
        console.log('Form submitted:', formData);
        // Reset form
        setFormData({
            name: '',
            email: '',
            phone: '',
            company: '',
            service: '',
            message: ''
        });
        alert('¡Gracias por contactarnos! Te responderemos pronto.');
    };

    return (
        <>
            <section
                className="contact-hero pt-40 pb-40 bg-cover bg-center relative"
                style={{
                    backgroundImage: `url(${contactBanner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',
                    backgroundRepeat: 'no-repeat'
                }}
            >                
                <div className="absolute inset-0 bg-black bg-opacity-40"></div>

                <div className="contain relative z-10">
                    <div className="w-full md:w-2/3 lg:w-1/2 h-full mt-36">
                        <div className="backdrop-blur-lg bg-white/10 border border-white/20 rounded-2xl p-8 shadow-2xl">
                            <div className="flex items-center mb-6">
                                <div className="w-12 h-12 rounded-full flex items-center justify-center bg-salient-primary/80 backdrop-blur-sm mr-4 shadow-lg">
                                    <i className="fa fa-envelope text-white text-xl"></i>
                                </div>
                                <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">Contáctanos</h1>
                            </div>
                            <p className="text-white text-opacity-95 text-lg leading-relaxed font-medium">
                                ¿Listo para transformar tu negocio? Agenda una consultoría gratuita y descubre cómo nuestras soluciones integrales en tecnología, marketing y energía pueden potenciar tu crecimiento.
                            </p>
                            <p className="text-white text-opacity-90 mt-4">
                                Nuestro equipo de especialistas está aquí para ofrecerte un servicio personalizado, transparente y de alto valor.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-salient-neutral-secondary py-20">
                <div className="contain">
                    <div 
                        className="flex">
                        {/* className="grid grid-cols-1 lg:grid-cols-2 gap-12"> */}
                        {/* Contact Form */}
                        {/* <div className="bg-white rounded-lg shadow-lg p-8">
                            <div className="mb-8">
                                <h2 className="text-3xl font-bold text-gray-800 mb-4">Envíanos un mensaje</h2>
                                <p className="text-gray-600">Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas.</p>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                                            Nombre completo *
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-salient-primary focus:border-transparent transition-colors"
                                            placeholder="Tu nombre"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                            Correo electrónico *
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-salient-primary focus:border-transparent transition-colors"
                                            placeholder="tu@email.com"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                                            Teléfono
                                        </label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-salient-primary focus:border-transparent transition-colors"
                                            placeholder="+52 442 342 4429"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                                            Empresa
                                        </label>
                                        <input
                                            type="text"
                                            id="company"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-salient-primary focus:border-transparent transition-colors"
                                            placeholder="Nombre de tu empresa"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                                        Servicio de interés
                                    </label>
                                    <select
                                        id="service"
                                        name="service"
                                        value={formData.service}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-salient-primary focus:border-transparent transition-colors"
                                    >
                                        <option value="">Selecciona un servicio</option>
                                        <option value="infraestructura-red">Infraestructura de red</option>
                                        <option value="consultoria-software">Consultoría en software</option>
                                        <option value="marketing-digital">Marketing digital</option>
                                        <option value="energia-limpia">Energías limpias</option>
                                        <option value="proyectos-electricos">Proyectos eléctricos</option>
                                        <option value="consultoria-general">Consultoría general</option>
                                        <option value="otro">Otro</option>
                                    </select>
                                </div>

                                <div>
                                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                                        Mensaje *
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="5"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-salient-primary focus:border-transparent transition-colors resize-vertical"
                                        placeholder="Cuéntanos sobre tu proyecto o necesidad..."
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    className="w-full bg-salient-primary text-white px-8 py-4 rounded-lg font-semibold hover:bg-salient-primary-hover transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl flex items-center justify-center"
                                >
                                    <i className="fa fa-paper-plane mr-2"></i>
                                    Enviar mensaje
                                </button>
                            </form>
                        </div> */}

                        {/* Contact Information */}
                        <div className="space-y-8 flex flex-row justify-center items-center gap-12 w-full">
                            {/* Contact Cards */}
                            <div className="bg-white rounded-lg shadow-lg p-8">
                                <h3 className="text-2xl font-bold text-gray-800 mb-6">Información de contacto</h3>
                                
                                <div className="space-y-6">
                                    <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-full bg-salient-primary flex items-center justify-center mr-4 flex-shrink-0">
                                            <i className="fa fa-envelope text-white"></i>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-800 mb-1">Correo electrónico</h4>
                                            <a href="mailto:salient.mkt@gmail.com" title='Envía un correo'> <p className="text-gray-600 hover:text-black">salient.mkt@gmail.com</p> </a>
                                            <p className="text-sm text-gray-500">Respuesta en menos de 24 horas</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-full bg-salient-primary flex items-center justify-center mr-4 flex-shrink-0">
                                            <i className="fa fa-phone text-white"></i>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-800 mb-1">Teléfono</h4>
                                            <a href="tel:+524423424429" title='Llámanos'> <p className="text-gray-600 hover:text-black">+52 442 342 4429</p> </a>
                                            <p className="text-sm text-gray-500">Lun - Vie: 9:00 AM - 6:00 PM</p>
                                        </div>
                                    </div>

                                    {/* <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-full bg-salient-primary flex items-center justify-center mr-4 flex-shrink-0">
                                            <i className="fa fa-map-marker text-white"></i>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-800 mb-1">Ubicación</h4>
                                            <p className="text-gray-600">Ciudad de México, México</p>
                                            <p className="text-sm text-gray-500">Atención presencial con cita previa</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            {/* Social Media & Additional Info */}
                            <div className="bg-white rounded-lg shadow-lg p-8">
                                <h3 className="text-2xl font-bold text-gray-800 mb-6">Síguenos</h3>
                                
                                <div className="flex space-x-4 mb-6">
                                    <a href="https://www.linkedin.com/company/109912525/" target='_blank' className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center text-white hover:bg-blue-700 transition-colors">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                    <a href="https://www.facebook.com/salientmkt/" target='_blank' className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center text-white hover:bg-blue-600 transition-colors">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    {/* <a href="#" className="w-12 h-12 rounded-full bg-pink-500 flex items-center justify-center text-white hover:bg-pink-600 transition-colors">
                                        <i className="fab fa-instagram"></i>
                                    </a> */}
                                </div>

                                {/* <div className="bg-gradient-to-r from-salient-primary to-salient-secondary p-6 rounded-lg text-white">
                                    <h4 className="font-bold text-lg mb-2">¿Necesitas ayuda inmediata?</h4>
                                    <p className="text-sm opacity-90 mb-4">
                                        Programa una videollamada gratuita de 30 minutos con nuestros especialistas.
                                    </p>
                                    <a 
                                        href="#"
                                        className="inline-flex items-center bg-white text-salient-primary px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
                                    >
                                        <i className="fa fa-calendar mr-2"></i>
                                        Agendar consulta
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="bg-white py-20">
                <div className="contain">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                            Preguntas frecuentes
                        </h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Encuentra respuestas rápidas a las preguntas más comunes sobre nuestros servicios.
                        </p>
                    </div>

                    <div className="max-w-4xl mx-auto space-y-6">
                        <div className="bg-gray-50 rounded-lg p-6">
                            <h4 className="font-semibold text-gray-800 mb-2">¿Cuánto tiempo toma recibir una respuesta?</h4>
                            <p className="text-gray-600">Nos comprometemos a responder todos los mensajes en menos de 24 horas durante días laborales.</p>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-6">
                            <h4 className="font-semibold text-gray-800 mb-2">¿La consultoría inicial tiene costo?</h4>
                            <p className="text-gray-600">No, ofrecemos una consultoría inicial completamente gratuita para entender tus necesidades y proponer la mejor solución.</p>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-6">
                            <h4 className="font-semibold text-gray-800 mb-2">¿Trabajan con empresas de cualquier tamaño?</h4>
                            <p className="text-gray-600">Sí, atendemos desde emprendedores y pequeñas empresas hasta corporativos, adaptando nuestras soluciones a cada necesidad.</p>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-6">
                            <h4 className="font-semibold text-gray-800 mb-2">¿Ofrecen soporte después de implementar las soluciones?</h4>
                            <p className="text-gray-600">Absolutamente. Todos nuestros servicios incluyen soporte continuo y mantenimiento para asegurar el éxito de tu proyecto.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="relative py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
                {/* Fondo con gradiente */}
                <div className="absolute inset-0 z-0 bg-gradient-to-br from-salient-primary to-gray-200 opacity-95"></div>
                <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
                    <div className="absolute -top-12 -left-12 w-64 h-64 rounded-full bg-white opacity-10"></div>
                    <div className="absolute top-1/2 right-0 w-80 h-80 rounded-full bg-white opacity-5"></div>
                    <div className="absolute bottom-0 left-1/3 w-40 h-40 rounded-full bg-white opacity-10"></div>
                </div>
                
                <div className="max-w-4xl mx-auto text-center relative z-10">
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 rounded-full flex items-center justify-center bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm">
                            <i className="fa fa-rocket text-white text-2xl"></i>
                        </div>
                    </div>

                    <h2 className="text-4xl sm:text-5xl font-bold text-white mb-2 drop-shadow-sm">
                        ¿Listo para comenzar?
                    </h2>
                    
                    <div className="w-16 h-1 bg-white bg-opacity-40 mx-auto my-6 rounded-full"></div>
                    
                    <p className="mt-4 text-xl sm:text-2xl text-white text-opacity-90 leading-relaxed font-light">
                        No esperes más para <span className="font-semibold">transformar tu negocio</span>. 
                        Contáctanos hoy y comencemos a trabajar juntos.
                    </p>
                    
                    <div className="mt-10">
                        <a
                            href="tel:+524423424429"
                            className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-gray-700 bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                        >
                            <i className="fa fa-phone mr-2"></i>
                            Llama ahora: +52 442 342 4429
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;